import { Skeleton } from '@frontend-workspace/react-shared-lib';

export function AllContractsGridSkeleton() {
  return (<>
    <div className="d-flex flex-row align-items-center flex-wrap">
      <div className='mb-3 mb-xxl-0 me-4'>
        <Skeleton animation="wave" height={50} width={150} />
      </div>
      <div className='mb-3 mb-xxl-0 me-4'>
        <Skeleton animation="wave" height={50} width={150} />
      </div>
      <div className='mb-3 mb-xxl-0 me-4'>
        <Skeleton animation="wave" height={50} width={150} />
      </div>
      <div className='mb-3 mb-xxl-0 me-4'>
        <Skeleton animation="wave" height={50} width={150} />
      </div>
    </div>
    <div className='d-flex justify-content-end'>
      <Skeleton animation="wave" width={150} height={50} />
    </div>
    <Skeleton variant="rectangular" animation="wave" width='100%' height={650} />
  </>);
}

export default AllContractsGridSkeleton;
